import React, { Fragment, useState, useEffect } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { ShoppingBag, Package, DollarSign, CreditCard } from "react-feather";
import axios from "axios";
import API_BASE_URL from '../../../Config/api';
import MonthlyBreakdownWidgets from '../../App/Ecommerce/OrderAnalytics/MonthlyBreakdown';
import { useCountUp } from '../../../_helper/AnimatedNumber';

const StatCard = ({ icon: Icon, title, value, iconBgColor, loading, index = 0 }) => {
    const animatedValue = useCountUp(value);
    return (
        <Col xl={3} lg={6} md={6} sm={6}>
            <Card className="o-hidden rf-stat-card" style={{ animationDelay: `${index * 80}ms` }}>
                <CardBody>
                    <div className="d-flex align-items-center">
                        <div className={`flex-shrink-0 bg-${iconBgColor} rounded-circle p-3`}>
                            <Icon className="text-white" size={24} />
                        </div>
                        <div className="flex-grow-1 ms-3">
                            <h6 className="mb-1 text-muted">{title}</h6>
                            <h3 className="mb-0 fw-bold">
                                {loading ? '...' : Math.round(animatedValue).toLocaleString()}
                            </h3>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

const OrderStatistics = () => {
    const [stats, setStats] = useState({
        totalOrders: 0,
        ordersShipped: 0,
        ordersPaid: 0,
        totalIncome: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/dashboard/stats`);
            setStats(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching dashboard stats:', error);
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <style>{`
                @keyframes rfFadeUp {
                    from { opacity: 0; transform: translateY(12px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .rf-stat-card { animation: rfFadeUp 480ms cubic-bezier(.22,.61,.36,1) both; transition: transform .15s ease, box-shadow .15s ease; }
                .rf-stat-card:hover { transform: translateY(-3px); box-shadow: 0 10px 24px rgba(0,0,0,.08); }
            `}</style>
            <Row>
                <StatCard
                    icon={ShoppingBag}
                    title="Total Orders"
                    value={stats.totalOrders}
                    iconBgColor="primary"
                    loading={loading}
                    index={0}
                />
                <StatCard
                    icon={Package}
                    title="Orders Shipped"
                    value={stats.ordersShipped}
                    iconBgColor="success"
                    loading={loading}
                    index={1}
                />
                <StatCard
                    icon={CreditCard}
                    title="Orders Paid"
                    value={stats.ordersPaid}
                    iconBgColor="warning"
                    loading={loading}
                    index={2}
                />
                <StatCard
                    icon={DollarSign}
                    title="Total Income"
                    value={stats.totalIncome}
                    iconBgColor="info"
                    loading={loading}
                    index={3}
                />
            </Row>
            <MonthlyBreakdownWidgets />
        </Fragment>
    );
};

export default OrderStatistics;
